import React, { useEffect, useState, useLayoutEffect } from 'react';
import { toast } from 'react-toastify';
import { Button, Form, Input, Label } from 'semantic-ui-react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { makeStyles } from '@mui/styles';
import { getDataUserDB, getUserPreferences, getUserShieldTokens, saveWalletOfUser } from '../../functions';
import './Wallet.scss'
import logo_shield from '../../assets/logo_shield.svg'
import coinbase from '../../assets/coinbase.svg'
import metamask from '../../assets/metamask.svg'
import trust_wallet from '../../assets/trust-wallet.svg'
import SwitchButton from '../../components/SwitchButton/SwitchButton';
import StepsToFollow from '../../components/StepsToFolllow/StepsToFollow';
import { underAgeValidate } from '../../helpers';
import ModalAge from '../../components/ModalAge/ModalAge';


const Wallet = () => {

    const [dataUser, setDataUser] = useState(null);
    const [balance, setBalance] = useState(0)
    const [wallet, setWallet] = useState(null)
    const [open, setOpen] = useState(false)
    const [openAgeModal, setOpenAgeModal] = useState(false)
    const [userPrefs, setUserPrefs] = useState(null)

    useEffect(() => {
        getUserPrefs()
        getDataUser()
        getShieldTokens()
    }, [])
    
    const getUserPrefs = async () => {
        const response = await getUserPreferences();
        if(response && response.result) {
            if(!response.result.empty) {
                setUserPrefs(response.result)
                if(!underAgeValidate(response.result.birthday)) {
                    setOpenAgeModal(true)
                }
            }
        }
    }

    const getDataUser = async () => {

        const response = await getDataUserDB();
        if(response && response.result) {
            if(response.result.empty) {
                toast.error('Este usuario no existe en la base de datos')
            } else {
                setDataUser(response.result)
                if(response.result.user_wallet) {
                    setWallet(response.result.user_wallet)
                }
            }
        } else if (response && response.error) {
            toast.error('Ha ocurrido un error al obtener la información, inténtelo de nuevo')
        }

    }

    const getShieldTokens = async () => {

        const response = await getUserShieldTokens();
        if(response && response.result) {
            setBalance(response.result.shield_points)
        } else if(response && response.empty) {
            setBalance(0)
        }

    }

    const handleOnChange = e => {
        const { value } = e.target;
        setWallet(value)
    }

    const handleOnChangeSwitch = (e) => {
        const { checked } = e.target;
        console.log(checked)
    }

    // Funcion para guardar la wallet
    const saveWallet = async (e) => {
        e.preventDefault();
        toast.info('Guardando wallet...')
        const response = await saveWalletOfUser(wallet);
        if(response && response.result) {
            toast.success('¡Tu nueva wallet ha sido guardada correctamente!')
        } else if(response && response.error) {
            toast.error('Ha ocurrido un error al guardar la wallet, pruebe de nuevo más tarde')
        }
    }

    const useStyles = makeStyles({
        root: {
            background: 'white',
            border: 0,
            borderRadius: 20,
            position: 'absolute',
            top: window.innerWidth > 700 ? '25%' : "25%",
            left: window.innerWidth > 700 ? '30%' : "2%",
            right: window.innerWidth > 700 ? '30%' : "2%",
            color: 'white',
            padding: ' 15px 30px',
        },
        rootAge: {
            background: 'white',
            border: 0,
            borderRadius: 50,
            position: 'absolute',
            top: window.innerWidth > 700 ? '30%' : "25%",
            left: window.innerWidth > 700 ? '28%' : "2%",
            right: window.innerWidth > 700 ? '28%' : "2%",
            color: 'white',
            padding: '2%',
        }
    });
    const classes = useStyles();

    console.log(userPrefs)

    return (
        <div className='wallet'>
            <h1>Monetización</h1>

            {
                userPrefs  && underAgeValidate(userPrefs.birthday) ? 
                console.log('is over 18') : 
                <Modal
                    open={openAgeModal}
                    onClose={() => setOpenAgeModal(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className={classes.rootAge}>
                        <ModalAge setOpenAgeModal={setOpenAgeModal} />
                    </Box>

                </Modal>
            }
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className={classes.root}>
                    <RenderModalDetail setOpen={setOpen} />
                </Box>
            </Modal>
            <div className='wallet_content'>
                <div className='wallet_content_left'>
                    <h2 style={{ color: '#96d4f4' }}>
                        Balance
                    </h2>
                    <div className='wallet_content_left_info'>
                        <img src={logo_shield} />
                        <div className='wallet_content_left_info_text'>
                            <h1 style={{ color: '#96d4f4' }}>{(parseFloat(balance).toFixed(2)).toString().replace('.', ',')}</h1>
                            <span style={{ color: '#96d4f4' }}>Shield Tokens</span>
                        </div>
                    </div>

                    <div className='wallet_content_left_footer'>
                        <img src={require('../../assets/settings.png').default} width="30px" />
                        <span>
                            En poco podrás recibir tus pagos, estamos trabajando para ello 
                        </span>
                    </div>
                </div>
                <div className='wallet_content_right'>
                    <Label>Información de tu cartera virtual</Label>
                    <Form onSubmit={saveWallet}>
                        <Form.Field>
                            <label>Dirección de tu Wallet</label>
                            <Input placeholder='0x48311Cf8C408C34c9af5131f271D97Eb26f9a712' value={wallet || ''} name='wallet_address' onChange={handleOnChange} required />
                        </Form.Field>
                        { window.innerWidth > 500 ? 
                        <div className='buttons'>
                            <div className='buttons_left'>
                                <span>
                                    Si no dispones de cartera virtual:
                                </span>
                            </div>
                            <div className='buttons_right'>
                                <Button className='btn_save' type='submit'>Guardar</Button>
                                <Button className='btn_redeem' type='button'>Redimir balance</Button>
                            </div>
                        </div> : 
                        <div className='buttons'>
                            <div className='buttons_right'>
                                <Button className='btn_redeem' type='submit'>Guardar</Button>
                                <Button className='btn_redeem' type='button'>Redimir</Button>
                            </div>
                            <div className='buttons_left'>
                                <span>
                                    Si no dispones de cartera virtual:
                                </span>
                            </div>
                            
                        </div>
                        }

                        <div className='btn_connect'>
                            <Button className='btn_redeem' type='button' onClick={() => setOpen(true)}>Conectar cartera</Button>
                            <div className='btn_connect_right'>
                                <SwitchButton onChange={handleOnChangeSwitch} checked={true} />
                                <span>Al activar el botón confirmas y permites la venta de tus datos</span>
                            </div>
                        </div>
                        
                    </Form>
                </div>
            </div>
            <div className='wallet_steps'>
                <h3>¿Cómo funciona?</h3>
                <StepsToFollow />
            </div>
        </div>
    )
};

function RenderModalDetail(props) {

    const { setOpen } = props;

    // Estilos de material ui
    const useStyles = makeStyles({
        cardDetails: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            alignItems: 'center'
        },
        title: {
            color: 'black',
            textAlign: 'center',
            margin: '0'
        },
        hr: {
            width: '100%',
            height: '1px',
            border: 'none',
            color: 'rgb(220, 220, 220)',
            background: 'rgb(220, 220, 220)'
        },
        details: {
            width: '100%'
        },
        h3: {
            textAlign: 'center',
            color: '#055c9d'
        },
        p: {
            color: 'black',
            textAlign: 'center',
            marginRight: '15%'
        },
        item: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '60%'
        },
        btn_connect: {
            display: 'flex',
            justifyContent: 'center',
            padding: '12px',
            borderRadius: '20px',
            backgroundColor: '#055c9d',
            color: 'white',
            fontWeight: 'bolder',
            border: 'none',

        }
    });
    const classes = useStyles();

    const data = [
        {
            name: 'MetaMask',
            image: metamask,
            url: 'https://metamask.io/'
        },
        {
            name: 'Coinbase',
            image: coinbase,
            url: 'https://www.coinbase.com/es'
        },
        {
            name: 'Trust Wallet',
            image: trust_wallet,
            url: 'https://trustwallet.com/es/'
        }
    ]

    const goToPage = url => {
        window.location.href = url
    }

    return (
        <div className={classes.cardDetails}>
            <h1 className={classes.title}>Conectar con</h1>
            <hr className={classes.hr} />
            {
                data.map(item => (
                    <div key={item.name} className={classes.item}>
                        <div style={{ display: 'flex' }}>
                            <img src={item.image} style={{ width: '40px', marginRight: '20%' }} />
                            <h3 className={classes.p}>{item.name}</h3>
                        </div>
                        <button className={classes.btn_connect} onClick={ () => goToPage(item.url) }>
                            Conectar
                        </button>
                    </div>
                ))
            }
        </div>
    )

}

export default (Wallet);
